var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapping-box-container"},[_c('div',{staticClass:"controls",attrs:{"id":"controls"}}),_c('LockLoader',{attrs:{"asset":"lock-icon.svg","text":"Iniciando análise..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }